import { useShowContext } from 'framework/show';
import { getValue, getLabel, setBlankTargetsIfNotSpecified } from 'framework/utils';
import { useUiTheme } from 'framework/uiTheme';
import { FieldLayoutProps, FieldProps } from '../types';

export type HtmlFieldLayoutType = ReactComponent<FieldLayoutProps>;

const HtmlField = ({ source = '', value, label }: FieldProps<object | string | number>) => {
  const { data } = useShowContext();
  const { HtmlFieldLayout } = useUiTheme<HtmlFieldLayoutType>();

  const fieldValue = getValue(value, (src?: string) => data && data.getValueBySource(src!), source).replace(
    /(\r\n|\n|\r)/gm,
    '<br />',
  );
  const formattedFieldValue = setBlankTargetsIfNotSpecified(fieldValue);

  const labelValue = getLabel(label, source);

  return <HtmlFieldLayout label={labelValue} value={formattedFieldValue} />;
};

export default HtmlField;
